import React from 'react'
import img01 from './q1.jpg'
import './index.css'

export default props => (
  <img src={img01} alt="" className="Endtest-q2" />
)



// WEBPACK FOOTER //
// ./src/content/endtest/q2/index.js